import styled from "@emotion/styled"

export const AppLoadingContainer = styled("div")(
  ({}) => `
  background-color: #00000050;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 100vw;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
`
)
